import { render, staticRenderFns } from "./LeadCard.vue?vue&type=template&id=67b8b277&scoped=true"
import script from "./LeadCard.vue?vue&type=script&lang=js"
export * from "./LeadCard.vue?vue&type=script&lang=js"
import style0 from "./LeadCard.vue?vue&type=style&index=0&id=67b8b277&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b8b277",
  null
  
)

export default component.exports